import { DatePipe } from '@angular/common';
import {inject, Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

export enum formats {
  date = 'date',
  datetime = 'datetime'
}

@Pipe({
  name: 'date',
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
  transform(
    value: any,
    format?: string
  ): any {
    if (value) {
      const adjustedValue = (typeof value === 'number') ? this.convertToMilliseconds(value) : value;
      const dateFormat = format ? format : this.getFormattedString(this.detectDateTimeType(value));
      return super.transform(adjustedValue, dateFormat);
    }
    return null;
  }

  convertToMilliseconds(value: any): number {
    // Check if the value is in seconds (10 digits)
    if (Math?.floor(value)?.toString()?.length === 10) {
      return value * 1000; // Convert seconds to milliseconds
    }
    return value;
  }

  detectDateTimeType(value: any): formats {
    let parsedDate;

    if (typeof value === 'number') {
      if (value.toString().length === 10) {
        parsedDate = moment.unix(value);
      } else if (value.toString().length === 13) {
        parsedDate = moment(value);
      }
    } else {
      parsedDate = moment(value);
    }

    if (parsedDate.format('HH:mm:ss') === '00:00:00') {
      return formats.date;
    } else {
      return formats.datetime;
    }
  }

  getFormattedString(value: formats): string {
    switch (value) {
      case formats.date:
        return 'd MMM yyyy';
      default:
        return 'd MMM yyyy | HH:mm';
    }
  }
}
